import React from "react"
import {
  ModalOuter,
  TModalTypes,
} from "../../../../components/Modal/ModalOuter"

const HaisyaHanreiModal: React.FC<TModalTypes> = (props) => {
  return <ModalOuter {...props}>HaisyaHanreiModal</ModalOuter>
}

export default HaisyaHanreiModal
